import { styled } from '@core-ui/react-stitch';
import { BRProps } from './types';

const GridDivision = styled.div(({ useBRRedesign }: BRProps) => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  minHeight: '500px',
  maxWidth: useBRRedesign ? '1920px' : '1280px',
  marginLeft: 'auto',
  marginRight: 'auto',
  flexWrap: 'wrap',
  '@media (min-width: 1024px)': {
    minWidth: '1024px',
    flexWrap: useBRRedesign ? 'wrap' : 'nowrap',
    '& .product-card-grid': {
      paddingLeft: '0',
    },
  },
}));

export default GridDivision;
